<script lang="ts">
    import CalculatorPercentChanceResult from "./components/CalculatorPercentChanceResult.svelte";
    import CalculatorBox from "./components/CalculatorBox.svelte";
    import CalculatorNumberInput from "./components/CalculatorNumberInput.svelte";
    import CalculatorSeparator from "./components/CalculatorSeparator.svelte";
    import CalculatorSection from "./components/CalculatorSection.svelte";
    import CalculatorNumberResult from "./components/CalculatorNumberResult.svelte";
    import CalculatorNumberAnswerRow from "./components/CalculatorNumberAnswerRow.svelte";

    function calculateSkillCheckProbability(
        diceSides: number,
        dc: number,
        modifier: number,
    ): number {
        return (diceSides - dc + modifier) / diceSides;
    }

    let modifier;

    let easyDC;
    let midDC;
    let hardDC;
    $: if (modifier) {
        easyDC = 10 + modifier - 5;
        midDC = 10 + modifier;
        hardDC = 10 + modifier + 5;
    }
</script>

<CalculatorBox>
    <div>
        <CalculatorSection>
            <p class="font-size-1-2-rem">If a PC has a modifier of</p>
            <CalculatorNumberInput
                bind:number={modifier}
                placeholder="Modifier"
            />
        </CalculatorSection>
        <CalculatorSeparator />
        <CalculatorSection>
            <p class="font-size-1-2-rem">What DC would they pass</p>
        </CalculatorSection>
        <CalculatorSection>
            <CalculatorNumberAnswerRow>
                <div class="font-size-1-5-rem">Easily (75%)?</div>
                <CalculatorNumberResult color={"green"} number={easyDC} />
            </CalculatorNumberAnswerRow>
            <CalculatorNumberAnswerRow>
                <div class="font-size-1-5-rem">Half the Time (50%)?</div>
                <CalculatorNumberResult color={"blue"} number={midDC} />
            </CalculatorNumberAnswerRow>
            <CalculatorNumberAnswerRow>
                <div class="font-size-1-5-rem">Rarely (25%)?</div>
                <CalculatorNumberResult color={"red"} number={hardDC} />
            </CalculatorNumberAnswerRow>
        </CalculatorSection>
    </div>
</CalculatorBox>
